import { db } from "../../firebase";
import {
  collection, query, where, orderBy, limit, onSnapshot,
  getDocs, startAfter, doc, setDoc, addDoc, serverTimestamp
} from "firebase/firestore";
import {
  THREADS_RESET, THREADS_LIVE_STARTED, THREADS_LIVE_SNAPSHOT, THREADS_LIVE_ERROR,
  THREADS_OLDER_REQUEST, THREADS_OLDER_SUCCESS, THREADS_OLDER_FAILURE,
  THREADS_SET_HAS_MORE
} from "./ThreadsTypes";
import { normEmail, threadKeyFromTwo } from "../../util/email";
import { Timestamp } from "firebase/firestore";

const PAGE = 500;
let _unsub = null, _liveKey = null;

export const threadsReset = () => { try{_unsub?.()}catch{} _unsub=null; _liveKey=null; return { type: THREADS_RESET }; };

// Live list of *my* threads (DMs or Groups)
// export const listenToThreadsLive = ({ meEmail, pageSize = PAGE }) => (dispatch) => {

  
//   const me = normEmail(meEmail);
//   if (!me) return () => {};
//   dispatch({ type: THREADS_LIVE_STARTED });

//   try { _unsub?.(); } catch {}
//   const qLive = query(
//     collection(db, "threads"),
//     where("participantsEmails", "array-contains", me),
//     orderBy("lastAt", "desc"),
//     limit(pageSize)
//   );

//   _liveKey = me;
//   _unsub = onSnapshot(qLive, (snap) => {
//     const docsDesc = snap.docs.map(d => ({ id: d.id, ...d.data(), _snapRef: d }));
//     dispatch({ type: THREADS_LIVE_SNAPSHOT, payload: { docsDesc } });
//     dispatch({ type: THREADS_SET_HAS_MORE, payload: docsDesc.length === pageSize });
//   }, (err) => dispatch({ type: THREADS_LIVE_ERROR, payload: err.message }));
//   return _unsub;
// };

export const listenToThreadsLive = ({ meEmail, pageSize = PAGE, isAdmin = false, viewMode = "mine" }) => (dispatch) => {
  const me = normEmail(meEmail);
  if (!me) return () => {};
  dispatch({ type: THREADS_LIVE_STARTED });

  try { _unsub?.(); } catch {}

  let qLive;

  if (isAdmin && viewMode === "others") {
 
    qLive = query(
      collection(db, "threads"),
      orderBy("lastAt", "desc"),
      limit(pageSize)
    );
  } else {
   
    qLive = query(
      collection(db, "threads"),
      where("participantsEmails", "array-contains", me),
      orderBy("lastAt", "desc"),
      limit(pageSize)
    );
  }

  _liveKey = isAdmin ? "admin" : me;

  _unsub = onSnapshot(
    qLive,
    (snap) => {
      const docsDesc = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
        _snapRef: d,
      }));
      dispatch({ type: THREADS_LIVE_SNAPSHOT, payload: { docsDesc } });
      dispatch({ type: THREADS_SET_HAS_MORE, payload: docsDesc.length === pageSize });
    },
    (err) => dispatch({ type: THREADS_LIVE_ERROR, payload: err.message })
  );

  return _unsub;
};

export const loadOlderThreads = () => async (dispatch, getState) => {
  const s = getState().threads;
  const me = normEmail(getState().loginAuth?.userDetails?.email);
  if (!me || s.loadingOlder || !s.hasMoreOlder || !s.oldestCursor) return;
  dispatch({ type: THREADS_OLDER_REQUEST });
  try {
    const qOlder = query(
      collection(db, "threads"),
      where("participantsEmails", "array-contains", me),
      orderBy("lastAt", "desc"),
      startAfter(s.oldestCursor),
      limit(PAGE)
    );
    const snap = await getDocs(qOlder);
    const batch = snap.docs.map(d => ({ id: d.id, ...d.data(), _snapRef: d }));
    dispatch({ type: THREADS_SET_HAS_MORE, payload: batch.length === PAGE });
    dispatch({ type: THREADS_OLDER_SUCCESS, payload: batch });
  } catch (err) {
    dispatch({ type: THREADS_OLDER_FAILURE, payload: err.message });
  }
};

// Ensure DM thread exists; returns threadId (the threadKey)
export const ensureDMThread = ({ aEmail, bEmail }) => async () => {
  const a = normEmail(aEmail), b = normEmail(bEmail);
  if (!a || !b || a === b) return null;
  const threadKey = threadKeyFromTwo(a, b);
  await setDoc(doc(db, "threads", threadKey), {
    isGroup: false,
    name: null,
    participantsEmails: threadKey.split("||"),
    threadKey,
    lastAt: serverTimestamp(),
    lastMessage: "",
    lastFrom: null,
    createdAt: serverTimestamp()
  }, { merge: true });
  return threadKey;
};

// Create a group; returns threadId (auto id)
export const createGroupThread = ({ name, participantsEmails }) => async () => {
  const parts = Array.from(new Set((participantsEmails || []).map(normEmail))).filter(Boolean);
  if (parts.length < 3) throw new Error("Group must have at least 3 participants (including you).");
  const ref = await addDoc(collection(db, "threads"), {
    isGroup: true,
    name: name || "New Group",
    participantsEmails: parts.sort(),
    lastAt: serverTimestamp(),
    lastMessage: "",
    lastFrom: null,
    createdAt: serverTimestamp()
  });
  return ref.id;
};

// Touch thread on send (update lastAt/lastMessage/lastFrom)
export const touchThreadOnSend = ({ threadId, lastMessage, lastFrom }) => async () => {
  await setDoc(doc(db, "threads", threadId), {
    lastAt: serverTimestamp(),
    lastMessage: lastMessage || "",
    lastFrom: normEmail(lastFrom || "")
  }, { merge: true });
};

export const markThreadRead = ({ threadId, meEmail }) => async () => {
  const id = (threadId || "");
  const me = (meEmail || "").toLowerCase();
  if (!id || !me) return;
  await setDoc(doc(db, "threads", id, "reads", me), {
    lastReadAt: Timestamp.now()
  }, { merge: true });
};

export const updateGroup = ({ threadId, name, participantsEmails }) => async () => {
  const parts = Array.from(new Set((participantsEmails || []).map(e => (e||"").toLowerCase()))).filter(Boolean);
  if (parts.length < 3) throw new Error("Group must have at least 3 members.");
  await setDoc(doc(db,"threads", threadId), {
    name: name || "Group",
    participantsEmails: parts.sort()
  }, { merge: true });
};
